export const PromotionTypes = {
  Bundle: 1,
  Offer: 2,
  New: 3,
  Prisregler: 4,
  XforY: 5
}

export function getPromotionTypeName (promotionType) {
  switch (promotionType) {
    case PromotionTypes.Bundle:
      return 'Bundle'
    case PromotionTypes.Prisregler:
      return 'Prisregler'
    case PromotionTypes.Offer:
      return 'Tilbud'
    case PromotionTypes.New:
      return 'Nyhet'
    case PromotionTypes.XforY:
      return 'X for Y'
    default:
      return ''
  }
}

export default PromotionTypes
